import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const popupStyles = require('../Popup/styles.pcss');
const styles = require('./recordStyles.pcss');

export type SelectOption = {
  value: string;
  label: string;
};

export type DisplayField = {
  label: string;
  value: string;
};

export type EditFieldConfig = {
  label: string;
  key: string;
  options: SelectOption[];
};

type Props = {
  open: boolean;
  title: string;
  displayFields: DisplayField[];
  editFields: EditFieldConfig[];
  initialValues: Record<string, string>;
  onClose: () => void;
  onSubmit: (values: Record<string, string>) => void;
};

type State = {
  values: Record<string, string>;
};

class EditRecordModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      values: { ...props.initialValues },
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.open !== this.props.open) {
      this.setState({
        values: { ...this.props.initialValues },
      });
    }
  }

  handleChange =
    (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      this.setState((prev) => ({
        values: { ...prev.values, [key]: e.target.value },
      }));
    };

  handleSubmit = () => {
    this.props.onSubmit(this.state.values);
  };

  render() {
    const { open, title, displayFields, editFields, onClose } = this.props;

    return (
      <Dialog
        maxWidth="sm"
        fullWidth
        className={popupStyles.dialogBox}
        PaperProps={{ className: styles.editRecordPaper }}
        open={open}
        onClose={onClose}
      >
        <div className={popupStyles.title}>
          {title}
          <IconButton
            color="inherit"
            onClick={onClose}
            className={popupStyles.closeIcon}
            aria-label="Close"
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className={popupStyles.body}>
          {displayFields.map((field, i) => (
            <div key={i} className={styles.fieldRow}>
              <strong>{field.label}:</strong> {field.value}
            </div>
          ))}
          {editFields.map((field) => (
            <TextField
              key={field.key}
              select
              label={field.label}
              value={this.state.values[field.key] ?? ''}
              onChange={this.handleChange(field.key)}
              fullWidth
              variant="outlined"
              className={styles.editFieldWrapper}
            >
              {field.options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          ))}
        </div>
        <div className={popupStyles.content}>
          <Button color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSubmit}
          >
            Save
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default EditRecordModal;
